<template>
  <div class="card mb-4">
    <div class="col-12">
      <transition name="slide-fade">
        <teacher-details
          v-if="isChildVisible"
          @close="hideChild"
          :teacher="teacher"
        />
      </transition>
      <transition name="slide-fade">
        <FormEditTeacher
          v-if="isEditVisible"
          @close="hideEditTeacher"
          @close-edit-form="hideEditTeacherEdit"
          :teacher="teacher"
        />
      </transition>
    </div>
    <div class="d-flex">
      <div class="card-header pb-0">
        <h6>{{ $t("teachers.teachers") }}</h6>
      </div>
      <div
        class="pe-md-3 d-flex align-items-center"
        :class="this.$store.state.isRTL ? 'me-md-auto' : 'ms-md-auto'"
      >
        <div class="me-3 mt-3">
          <form class="input-group">
            <input
              type="text"
              class="form-control back"
              v-model="searchQuery"
              :placeholder="
                this.$store.state.isRTL ? 'أكتب هنا...' : $t('teachers.search')
              "
            />
          </form>
        </div>
      </div>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th
                class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 col-2"
              >
                {{ $t("teachers.teacher") }}
              </th>
              <th
                class="text-uppercase text-secondary text-xxs text-center font-weight-bolder opacity-7 ps-2 col-2"
              >
                {{ $t("teachers.address") }}
              </th>
              <th
                class="text-uppercase text-secondary text-xxs text-center font-weight-bolder opacity-7 ps-2 col-1"
              >
                {{ $t("teachers.mobile") }}
              </th>
              <th
                class="text-center text-uppercase text-secondary text-center text-xxs font-weight-bolder opacity-7 col-1"
              >
                {{ $t("teachers.activ") }}
              </th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 col-1"
              >
                {{ $t("teachers.employedSince") }}
              </th>
              <th class="text-secondary opacity-7 col-3"></th>
              <th
                class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 col-2"
              >
                {{ $t("teachers.details") }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in filteredTeachers" :key="item.id">
              <td>
                <div class="d-flex px-2 py-1">
                  <div>
                    <soft-avatar
                      :img="item.image"
                      size="sm"
                      border-radius="lg"
                      class="me-3"
                      alt="user1"
                    />
                  </div>
                  <div class="d-flex flex-column justify-content-center">
                    <h6 class="mb-0 text-sm">{{ item.name }}</h6>
                    <p class="text-xs text-secondary mb-0">
                      {{ item.email }}
                    </p>
                  </div>
                </div>
              </td>
              <td>
                <p class="text-xs font-weight-bold mb-0 text-center">
                  {{ item.address }}
                </p>
              </td>
              <td class="text-center">
                <p class="text-xs font-weight-bold mb-0">{{ item.mobile }}</p>
              </td>
              <td class="align-middle text-center text-sm">
                <soft-badge
                  v-if="!item.deleted_at"
                  color="success"
                  variant="gradient"
                  size="sm"
                >
                  {{ $t("global.yes") }}
                </soft-badge>
                <soft-badge
                  v-else-if="item.deleted_at"
                  color="secondary"
                  variant="gradient"
                  size="sm"
                >
                  {{ $t("global.no") }}
                </soft-badge>
              </td>
              <td class="align-middle text-center">
                <span class="text-secondary text-xs font-weight-bold">{{
                  item.employed_from
                }}</span>
              </td>
              <td class="align-middle text-center">
                <div v-if="lastSeason">
                  <div v-if="!item.deleted_at">
                    <a
                      class="btn btn-link text-dark px-3 mb-0"
                      href="javascript:;"
                      @click="editTeacher(item)"
                    >
                      <i
                        class="fas fa-pencil-alt text-dark me-2"
                        aria-hidden="true"
                      ></i
                      >{{ $t("global.edit") }}
                    </a>
                    <a
                      class="btn btn-link text-danger text-gradient px-3 mb-0"
                      href="javascript:;"
                      @click="deleteTeacher(item)"
                    >
                      <i class="far fa-trash-alt me-2" aria-hidden="true"></i
                      >{{ $t("global.delete") }}
                    </a>
                  </div>
                  <div v-else>
                    <a
                      v-if="userRole === 'Super-Admin' || userRole === 'Admin'"
                      class="me-3"
                      href="javascript:;"
                      @click="activateTeacher(item)"
                    >
                      <soft-badge
                        :class="item.valid ? 'disabled' : 'enabled'"
                        :color="!item.valid ? 'success' : 'secondary'"
                        class="custom-width"
                        variant="gradient"
                        size="lg"
                      >
                        {{ !item.valid ? $t("global.activate") : "" }}
                      </soft-badge>
                    </a>
                    <a
                      v-if="userRole === 'Super-Admin' || userRole === 'Admin'"
                      href="javascript:;"
                      class="me-3"
                      @click="permanentDeleteTeacher(item)"
                    >
                      <soft-badge
                        :class="item.valid ? 'disabled' : 'enabled'"
                        :color="!item.valid ? 'danger' : 'secondary'"
                        class="custom-width"
                        variant="gradient"
                        size="lg"
                      >
                        {{ !item.valid ? $t("global.deleteForever") : "" }}
                      </soft-badge>
                    </a>
                  </div>
                </div>
              </td>
              <td class="align-middle text-center text-sm">
                <a href="#" @click="showTeacher(item)" class="ms-3">
                  <soft-badge color="success" variant="gradient" size="sm">
                    {{ $t("teachers.details") }}
                  </soft-badge>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import SoftAvatar from "@/components/SoftAvatar.vue";
import SoftBadge from "@/components/SoftBadge.vue";
import TeacherDetails from "../components/TeacherDetails";
import FormEditTeacher from "@/components/FormEditTeacher";
import swal from "sweetalert2";
import axios from "axios";

export default {
  name: "teacher-list",
  props: {
    teachers: {
      type: Array,
      required: true,
      default: () => [],
    },
    lastSeason: {
      type: Boolean,
      required: true,
    },
    isEditFormVisible: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      teacher: {},
      isChildVisible: false,
      isEditVisible: false,
      searchQuery: "",
      searchedTeachers: this.teachers,
    };
  },
  components: {
    SoftAvatar,
    SoftBadge,
    TeacherDetails,
    FormEditTeacher,
  },
  watch: {
    isEditFormVisible(new_value) {
      this.isEditVisible = new_value;
    },
  },
  computed: {
    filteredTeachers() {
      const search = this.searchQuery.trim().toLowerCase();

      if (!search) {
        this.getSearchedTeachers();
        this.$emit("show-pagination");
        return this.teachers;
      }

      this.$emit("hide-pagination");
      return this.searchedTeachers.filter((teacher) => {
        return teacher.name.toLowerCase().includes(search);
      });
    },
    userRole() {
      return localStorage.getItem("userRole");
    },
  },
  methods: {
    async getSearchedTeachers() {
      const res = await axios.get("get-searched-teachers");
      this.searchedTeachers = res.data.teachers;
    },
    editTeacher(teacher) {
      this.teacher = teacher;
      this.isEditVisible = true;
      this.isChildVisible = false;
      this.scrollToTop();
      this.$emit("hide-create-form");
    },
    async deleteTeacher(teacher) {
      const test = await axios.get("check-teachers-subcourses/" + teacher.id);
      let optionalText = "";
      test.data.subcourses.forEach(
        (item) => (optionalText += "<br>- " + item.title + ", ")
      );
      let text =
        optionalText != ""
          ? this.$t("teachers.detail.teachSubcourses") + optionalText
          : "";
      const result = await swal.fire({
        title: this.$t("global.areYouSure"),
        html: text,
        icon: "question",
        showCancelButton: true,
        cancelButtonText: this.$t("global.no"),
        cancelButtonColor: "#f54539",
        confirmButtonText: this.$t("global.yes"),
        confirmButtonColor: "#82d616",
      });
      if (result.isConfirmed) {
        try {
          const response = await axios.delete("teacher/" + teacher.id);
          swal.fire({
            icon: "success",
            title: this.$t(response.data.message),
            showConfirmButton: true,
            width: "64em",
          });
          this.$emit("get-teachers");
        } catch (error) {
          console.log(error);
        }
      } else {
        swal.fire({
          title: this.$t("global.deletingCancelled"),
          text: "",
          icon: "success",
        });
      }
    },
    showTeacher(teacher) {
      this.teacher = teacher;
      this.isChildVisible = true;
      this.isEditVisible = false;
      this.scrollToTop();
    },
    hideChild() {
      this.isChildVisible = false;
    },
    hideEditTeacher() {
      this.isEditVisible = false;
    },
    hideEditTeacherEdit(teacher) {
      this.teacher = teacher;
      this.isEditVisible = false;
      this.$emit("get-teachers");
    },
    async activateTeacher(teacher) {
      const result = await swal.fire({
        title: this.$t("global.areYouSure"),
        text: "",
        icon: "question",
        showCancelButton: true,
        cancelButtonText: this.$t("global.no"),
        cancelButtonColor: "#f54539",
        confirmButtonText: this.$t("global.yes"),
        confirmButtonColor: "#82d616",
      });
      if (result.isConfirmed) {
        try {
          swal.fire({
            title: this.$t("global.loading"),
            text: this.$t("global.plsWait"),
            allowOutsideClick: false,
            didOpen: () => {
              swal.showLoading();
            },
          });
          const response = await axios.post("activate-teacher", {
            teacher: teacher.id,
          });
          if (response.status == 200) {
            swal.close();
            swal.fire({
              icon: "success",
              //showLoaderOnConfirm: true,
              title: this.$t(response.data.message),
              showConfirmButton: true,
            });
          }
        } catch (error) {
          if (
            error.response &&
            (error.response.status === 403 || error.response.status === 400)
          ) {
            swal.close();
            swal.fire({
              title: this.$t("global.error") + "!",
              text:
                this.$t(error.response.data.message) ||
                "You are not authorized to perform this action.",
              icon: "error",
            });
          } else {
            swal.close();
            swal.fire({
              title: this.$t("global.error") + "!",
              text: "Something went wrong. Please try again later.",
              icon: "error",
            });
          }
        }
      } else {
        swal.close();
        swal.fire({
          title: this.$t("global.creatingCancelled"),
          text: "",
          icon: "success",
        });
      }
      this.$emit("get-teachers");
    },
    async permanentDeleteTeacher(teacher) {
      const result = await swal.fire({
        title: this.$t("global.areYouSure"),
        text: this.$t("teachers.teacherPermanentlyDelete"),
        icon: "question",
        showCancelButton: true,
        cancelButtonText: this.$t("global.no"),
        cancelButtonColor: "#f54539",
        confirmButtonText: this.$t("global.yes"),
        confirmButtonColor: "#82d616",
      });
      if (result.isConfirmed) {
        try {
          swal.fire({
            title: this.$t("global.loading"),
            text: this.$t("global.plsWait"),
            allowOutsideClick: false,
            didOpen: () => {
              swal.showLoading();
            },
          });
          const response = await axios.delete(
            "permanently-delete-teacher/" + teacher.id
          );
          if (response.status == 200) {
            swal.close();
            swal.fire({
              icon: "success",
              //showLoaderOnConfirm: true,
              title: this.$t(response.data.message),
              showConfirmButton: true,
            });
            this.$emit("get-teachers");
          }
        } catch (error) {
          if (
            error.response &&
            (error.response.status === 403 || error.response.status === 400)
          ) {
            swal.close();
            swal.fire({
              title: this.$t("global.error") + "!",
              text:
                this.$t(error.response.data.message) ||
                "You are not authorized to perform this action.",
              icon: "error",
            });
          } else {
            swal.close();
            swal.fire({
              title: this.$t("global.error") + "!",
              text: "Something went wrong. Please try again later.",
              icon: "error",
            });
          }
        }
      } else {
        swal.fire({
          title: this.$t("global.deletingCancelled"),
          text: "",
          icon: "success",
        });
      }
    },
    scrollToTop() {
      setTimeout(() => {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }, 100);
    },
  },
};
</script>
